<!--商品基本信息，包括：价格、名称、活动状态-->
<template>
  <div class="groupon-item" v-if="groupItemInfo">
    <img :src="groupItemInfo.userAvatar" class="g-avatar" alt="" />
    <div class="g-name">{{ groupItemInfo.nickName }}</div>
    <div class="g-content">
      <div class="g-status" tabindex="0">
        <div class="g-left">
          差
          <i>{{ groupItemInfo.needNumber }}人</i>
          成团
        </div>
        <div class="g-time" :aria-label="`距结束还有${formatTimeLabel()}`">
          距结束&nbsp;
          <v-count-down
            ref="count"
            class="q-count"
            showMSecond
            showMSecondGif
            v-if="groupItemInfo.expireTime > groupItemInfo.currentTime"
            :current="groupItemInfo.currentTime * 1"
            :start="groupItemInfo.startTime * 1"
            :end="groupItemInfo.expireTime * 1"
            :endFun="countEnd"
          ></v-count-down>
        </div>
      </div>
      <v-button size="small" class="g-btn" @click="joinGroup">去参团</v-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrouponItem',
  props: {
    groupItemInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    groupItemInfo(val) {
      // 重置定时器
      this.$nextTick(() => {
        if (val.expireTime > val.currentTime) {
          this.$refs.count.init()
        }
      })
    }
  },
  methods: {
    formatTimeLabel() {
      let time = this.groupItemInfo.expireTime * 1 - this.groupItemInfo.currentTime * 1
      let h = parseInt(time / 3600000) % 24
      let m = parseInt(time / 60000) % 60
      return `${h}小时${m}分`
    },
    // 倒计时结束后重新获取数据
    countEnd() {
      this.$emit('refreshGroupon')
    },
    joinGroup() {
      this.$emit('joinGroup', this.groupItemInfo.grouponId)
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
